import React from 'react';
import { withRouter } from 'react-router';

import {
  FREE_TRIAL_BLOCKER_URL,
  SIGN_UP_URL,
  STUDENTS_ASSIGNMENTS_LIST_URL
} from 'config/urls';
import { isEmpty } from 'lodash';

import { stringifyParams } from 'utils/urls';

import UserContext from 'components/UserContext';

import { fetchFreeTrialData, me } from './sdk';

const TeacherRequired = (WrappedComponent) => {
  class HOC extends React.Component {
    redirectToLogin = ({ fromMeetingFeed }) => {
      const {
        location: { pathname, search }
      } = this.props;

      let searchParams = stringifyParams({ next: pathname + search });

      if (fromMeetingFeed) {
        const pathnameList = pathname.split('/');

        searchParams = stringifyParams({
          next: pathname + search,
          invitationIdentifier: pathnameList[3]
        });
      }

      this.props.history &&
        this.props.history.push({
          pathname: SIGN_UP_URL,
          search: searchParams
        });
    };

    redirectToStudentApp = () =>
      this.props.history &&
      this.props.history.push(STUDENTS_ASSIGNMENTS_LIST_URL);

    fetchMe = async () => {
      const promises = [me(), fetchFreeTrialData()];
      const resolved = await Promise.all(promises);

      const { data: user } = resolved[0];
      const freeTrialData = resolved[1];

      if (!isEmpty(user)) {
        user.freeTrialData = freeTrialData.data;
      }

      return user;
    };

    ensureUser = ({ user, setUser, fromMeetingFeed = false }) => {
      if (!user) {
        this.fetchMe().then((me) => {
          !isEmpty(me)
            ? setUser(me)
            : this.redirectToLogin({ fromMeetingFeed });
        });
        return null;
      }

      if (user && user.is_teacher && !user.is_in_free_trial && !user.is_paid) {
        this.props.history.push(FREE_TRIAL_BLOCKER_URL);
        return null;
      }

      if (user && !user.is_teacher && user.student_id) {
        this.redirectToStudentApp();
        return null;
      }

      return user;
    };

    render() {
      return (
        <UserContext.Consumer>
          {({ user, setUser }) => {
            const {
              location: { pathname }
            } = this.props;

            const pathnameList = pathname.split('/');

            // Check whether we are on the "/teacher/meetings/:invitationIdentifier" page
            const fromMeetingFeed =
              pathnameList.length === 4 &&
              pathnameList[1] === 'teacher' &&
              pathnameList[2] === 'meetings';

            const ensuredUser = fromMeetingFeed
              ? this.ensureUser({
                  user,
                  setUser,
                  fromMeetingFeed: true
                })
              : this.ensureUser({ user, setUser });

            if (ensuredUser) {
              return <WrappedComponent user={ensuredUser} {...this.props} />;
            }
          }}
        </UserContext.Consumer>
      );
    }
  }

  return withRouter(HOC);
};

export default TeacherRequired;
